module.exports = __webpack_public_path__ + "img/iconfont.33983889.svg";